import React from "react";

import DashboardOutlinedIcon from "@material-ui/icons/DashboardOutlined";
import TvIcon from "@material-ui/icons/Tv";
import Description from "@material-ui/icons/Description";
import GridOn from "@material-ui/icons/GridOn";
import EventNoteIcon from "@material-ui/icons/EventNote";
import ContactPhoneOutlinedIcon from "@material-ui/icons/ContactPhoneOutlined";
import LocalOfferIcon from "@material-ui/icons/LocalOffer";
import PeopleAltOutlinedIcon from "@material-ui/icons/PeopleAltOutlined";
import AccountTreeOutlinedIcon from "@material-ui/icons/AccountTreeOutlined";
import SyncAltIcon from "@material-ui/icons/SyncAlt";
import DeviceHubOutlined from "@material-ui/icons/DeviceHubOutlined";
import LocalAtmIcon from "@material-ui/icons/LocalAtm";
import SettingsOutlinedIcon from "@material-ui/icons/SettingsOutlined";
import FlashOnIcon from "@material-ui/icons/FlashOn";
import Schedule from "@material-ui/icons/Schedule";
import ForumIcon from "@material-ui/icons/Forum";
import ListIcon from "@material-ui/icons/List";
import PeopleIcon from "@material-ui/icons/People";
import EventAvailableIcon from "@material-ui/icons/EventAvailable";
import AnnouncementIcon from "@material-ui/icons/Announcement";
import LibraryBooksIcon from "@material-ui/icons/LibraryBooks";
import AttachMoneyIcon from "@material-ui/icons/AttachMoney";
import AllInclusiveIcon from "@material-ui/icons/AllInclusive";
import FlagOutlinedIcon from "@material-ui/icons/FlagOutlined";
import ReportProblemOutlinedIcon from "@material-ui/icons/ReportProblemOutlined";
import ReceiptOutlinedIcon from "@material-ui/icons/ReceiptOutlined";
import CodeRoundedIcon from "@material-ui/icons/CodeRounded";
import PhonelinkSetupIcon from "@material-ui/icons/PhonelinkSetup";
import {
  ViewKanban,
  TravelExplore,
  Assignment as AssignmentIcon,
  Campaign as CampaignIcon,
  Webhook as WebhookIcon,
  ShapeLine as ShapeLineIcon,
} from "@mui/icons-material";

import { hasPermission, hasAnyPermission } from "../helpers/hasPermission";
import { i18n } from "../translate/i18n";

// Config central do menu/abas do layout Novo (projeto 2026-10-21, ver
// PROMPT.md em D:\voicechat\novo layout). NAO reimplementa permissao -
// cada "gate" abaixo e' a MESMA expressao usada em MainListItems.js
// (Classico) pro item equivalente, so' que lida aqui como funcao em vez
// de JSX inline, pra poder ser consultada tanto pela barra lateral
// quanto pelas abas de subsecao. Se um gate mudar no Classico, precisa
// mudar aqui tambem (nao ha' como importar diretamente o JSX condicional
// de dentro de MainListItems.js sem reescrever aquele arquivo).

export const isGerenciaVisible = (user) =>
  (user.profile === "user" && user.showDashboard === "enabled") || user.allowRealTime === "enabled" || user.profile === "admin";

export const GERENCIA_TABS = [
  {
    to: "/",
    label: "Dashboard",
    icon: <DashboardOutlinedIcon fontSize="small" />,
    isVisible: (user) => user.profile !== "user" || user.showDashboard === "enabled",
  },
  {
    to: "/painel-tv",
    label: "Painel TV",
    icon: <TvIcon fontSize="small" />,
    isVisible: (user) => user.profile !== "user" || user.showDashboard === "enabled",
  },
  {
    to: "/reports",
    label: i18n.t("mainDrawer.listItems.reports"),
    icon: <Description fontSize="small" />,
    isVisible: (user) => user.profile !== "user" || user.showDashboard === "enabled",
  },
  {
    to: "/moments",
    label: i18n.t("mainDrawer.listItems.chatsTempoReal"),
    icon: <GridOn fontSize="small" />,
    isVisible: (user) => user.profile !== "user" || user.allowRealTime === "enabled",
  },
  {
    to: "/on-call",
    label: "Sobreaviso",
    icon: <EventNoteIcon fontSize="small" />,
    isVisible: (user) => hasPermission(user, "menu:on-call") || hasPermission(user, "oncall:calendar-view") || user.profile === "admin",
  },
];

export const CONTATOS_TABS = [
  {
    to: "/contacts",
    label: i18n.t("mainDrawer.listItems.contacts"),
    icon: <ContactPhoneOutlinedIcon fontSize="small" />,
    isVisible: () => true,
  },
  {
    to: "/tags",
    label: i18n.t("mainDrawer.listItems.tags"),
    icon: <LocalOfferIcon fontSize="small" />,
    isVisible: () => true,
  },
];

// Adicionado 2026-10-21 (caso real: "Comercial" ficou sem nenhum jeito
// de abrir no layout Novo depois que virou parte do grupo Produtividade
// no Classico - essa aba nao existia ainda). Gates identicos aos itens
// correspondentes em MainListItems.js (Classico).
// Ordem pedida pelo usuario 2026-10-21: Comercial, Kanban, Agendamentos,
// Tarefas, Respostas Rapidas, Chat Interno por ultimo.
export const PRODUTIVIDADE_TABS = [
  {
    to: "/commercial",
    label: "Comercial",
    icon: <TravelExplore fontSize="small" />,
    isVisible: (user, flags) => !!flags?.showKanban && (hasPermission(user, "menu:commercial") || user.profile === "admin"),
  },
  {
    to: "/boards",
    label: i18n.t("mainDrawer.listItems.kanban"),
    icon: <ViewKanban fontSize="small" />,
    isVisible: (user, flags) => !!flags?.showKanban && (hasPermission(user, "menu:boards") || user.profile === "admin"),
  },
  {
    to: "/clientes-criticos",
    label: "Clientes Críticos",
    icon: <ReportProblemOutlinedIcon fontSize="small" />,
    isVisible: (user, flags) => !!flags?.showKanban && (hasPermission(user, "menu:clientes-criticos") || user.profile === "admin"),
  },
  {
    to: "/schedules",
    label: i18n.t("mainDrawer.listItems.schedules"),
    icon: <Schedule fontSize="small" />,
    isVisible: (user, flags) => !!flags?.showSchedules && (hasPermission(user, "menu:schedules") || user.profile === "admin"),
  },
  {
    to: "/tasks",
    label: "Tarefas",
    icon: <AssignmentIcon fontSize="small" />,
    isVisible: (user, flags) => !!flags?.showKanban && (hasPermission(user, "menu:tasks") || user.profile === "admin"),
  },
  {
    to: "/quick-messages",
    label: i18n.t("mainDrawer.listItems.quickMessages"),
    icon: <FlashOnIcon fontSize="small" />,
    isVisible: () => true,
  },
  {
    to: "/chats",
    label: i18n.t("mainDrawer.listItems.chats"),
    icon: <ForumIcon fontSize="small" />,
    isVisible: (user, flags) => !!flags?.showInternalChat,
  },
];

// Adicionado 2026-10-22 (achado da auditoria pedida pelo usuario:
// "mapeie tudo o que tem no layout antigo, pois esta faltando muita
// coisa"). No Classico, Campanhas + Flowbuilder + Informativos vivem
// juntos num unico grupo de menu ("Campanhas & Automação" em
// MainListItems.js) - aqui ficam juntos na mesma aba por isso, nao
// porque sejam a mesma feature. Sem isso o grupo "campanhas" do Novo
// so' tinha o item padrao (/campaigns) e nada mais era alcancavel.
export const CAMPANHAS_TABS = [
  {
    to: "/campaigns",
    label: i18n.t("campaigns.subMenus.list"),
    icon: <ListIcon fontSize="small" />,
    isVisible: (user, flags) => !!flags?.showCampaigns && (hasPermission(user, "menu:campaigns") || user.profile === "admin"),
  },
  {
    to: "/contact-lists",
    label: i18n.t("campaigns.subMenus.listContacts"),
    icon: <PeopleIcon fontSize="small" />,
    isVisible: (user, flags) => !!flags?.showCampaigns && (hasPermission(user, "menu:campaigns") || user.profile === "admin"),
  },
  {
    to: "/campaigns-config",
    label: i18n.t("campaigns.subMenus.settings"),
    icon: <SettingsOutlinedIcon fontSize="small" />,
    isVisible: (user, flags) => !!flags?.showCampaigns && (hasPermission(user, "menu:campaigns") || user.profile === "admin"),
  },
  {
    to: "/phrase-lists",
    label: i18n.t("flowbuilder.subMenus.campaign"),
    icon: <EventAvailableIcon fontSize="small" />,
    isVisible: (user) => hasPermission(user, "menu:flowbuilder") || user.profile === "admin",
  },
  {
    to: "/flowbuilders",
    label: i18n.t("flowbuilder.subMenus.conversation"),
    icon: <ShapeLineIcon fontSize="small" />,
    isVisible: (user) => hasPermission(user, "menu:flowbuilder") || user.profile === "admin",
  },
  {
    to: "/announcements",
    label: i18n.t("mainDrawer.listItems.annoucements"),
    icon: <AnnouncementIcon fontSize="small" />,
    isVisible: (user) => !!user.super,
  },
];

// Adicionado 2026-10-22 (mesma auditoria) - grupo "ia" tinha tabs: null,
// entao so' /knowledge-base era alcancavel; Custos de IA, Prompts e
// Confirmacao de Pendencias nao tinham like nenhum no layout Novo.
export const IA_TABS = [
  {
    to: "/knowledge-base",
    label: "Base de Conhecimento",
    icon: <LibraryBooksIcon fontSize="small" />,
    isVisible: (user) => hasPermission(user, "menu:faq-moderation") || hasPermission(user, "menu:files") || user.profile === "admin",
  },
  {
    to: "/ai-costs",
    label: i18n.t("mainDrawer.listItems.aiCosts"),
    icon: <AttachMoneyIcon fontSize="small" />,
    isVisible: (user) => hasPermission(user, "menu:ai-costs") || user.profile === "admin",
  },
  {
    to: "/prompts",
    label: i18n.t("mainDrawer.listItems.prompts"),
    icon: <AllInclusiveIcon fontSize="small" />,
    isVisible: (user, flags) => !!flags?.showOpenAi && (hasPermission(user, "menu:prompts") || user.profile === "admin"),
  },
  {
    to: "/pending-confirmations",
    label: "Confirmação de Pendências",
    icon: <FlagOutlinedIcon fontSize="small" />,
    isVisible: (user) => user.profile === "admin" || (user.profile === "user" && user.allowPendingConfirmation === "enabled"),
  },
];

export const isConfiguracoesVisible = (user) =>
  user.profile === "admin" || (user.profile === "user" && (user.allowConnections === "enabled" || hasAnyPermission(user)));

export const CONFIG_TABS = [
  {
    to: "/users",
    label: i18n.t("mainDrawer.listItems.users"),
    icon: <PeopleAltOutlinedIcon fontSize="small" />,
    isVisible: (user) => hasPermission(user, "menu:users") || user.profile === "admin",
  },
  {
    to: "/queues",
    label: i18n.t("mainDrawer.listItems.queues"),
    icon: <AccountTreeOutlinedIcon fontSize="small" />,
    isVisible: (user) => hasPermission(user, "menu:queues") || user.profile === "admin",
  },
  {
    to: "/connections",
    label: i18n.t("mainDrawer.listItems.connections"),
    icon: <SyncAltIcon fontSize="small" />,
    isVisible: (user) => user.profile !== "user" || user.allowConnections === "enabled",
  },
  {
    to: "/queue-integration",
    label: i18n.t("mainDrawer.listItems.queueIntegration"),
    icon: <DeviceHubOutlined fontSize="small" />,
    isVisible: (user, flags) => !!flags?.showIntegrations && (hasPermission(user, "menu:queue-integration") || user.profile === "admin"),
  },
  {
    to: "/financeiro",
    label: i18n.t("mainDrawer.listItems.financeiro"),
    icon: <LocalAtmIcon fontSize="small" />,
    isVisible: (user) => hasPermission(user, "menu:financeiro") || user.profile === "admin",
  },
  {
    to: "/settings",
    label: i18n.t("mainDrawer.listItems.settings"),
    icon: <SettingsOutlinedIcon fontSize="small" />,
    isVisible: (user) => hasPermission(user, "menu:settings") || user.profile === "admin",
  },
  // Adicionado 2026-10-22 (auditoria "mapeie tudo"): esses 3 itens
  // existem no Classico (subsecoes "Conexões"/"Operacional" dentro de
  // Configurações) mas nao estavam nesta lista - sem like nenhum pra
  // chegar neles no layout Novo (achado real: usuario foi procurar o
  // Monitor Sefaz e nao encontrou).
  {
    to: "/sefaz-monitor",
    label: i18n.t("mainDrawer.listItems.sefazMonitor"),
    icon: <ReceiptOutlinedIcon fontSize="small" />,
    isVisible: (user) => hasPermission(user, "menu:sefaz-monitor") || user.profile === "admin",
  },
  {
    to: "/messages-api",
    label: i18n.t("mainDrawer.listItems.messagesAPI"),
    icon: <CodeRoundedIcon fontSize="small" />,
    isVisible: (user, flags) => !!flags?.showExternalApi && (hasPermission(user, "menu:messages-api") || user.profile === "admin"),
  },
  {
    to: "/allConnections",
    label: i18n.t("mainDrawer.listItems.allConnections"),
    icon: <PhonelinkSetupIcon fontSize="small" />,
    isVisible: (user) => !!user.super,
  },
];

// Grupos sem lista de abas definida no PROMPT.md ainda - o item do menu
// leva direto pra primeira tela, sem linha de abas. Ver nota na entrega
// (secao 6.6 do PROMPT.md: "Nao redesenhe a estrutura dessas telas
// agora. Me liste quais precisariam de um mockup proprio").
const GROUPS = [
  { key: "atendimentos", test: (p) => p.startsWith("/tickets"), tabs: null },
  { key: "gerencia", test: (p) => GERENCIA_TABS.some((t) => (t.to === "/" ? p === "/" : p.startsWith(t.to))), tabs: GERENCIA_TABS },
  { key: "produtividade", test: (p) => ["/quick-messages", "/boards", "/tasks", "/chats", "/kanban", "/schedules", "/commercial", "/clientes-criticos"].some((r) => p.toLowerCase().startsWith(r)), tabs: PRODUTIVIDADE_TABS },
  { key: "contatos", test: (p) => CONTATOS_TABS.some((t) => p.startsWith(t.to)), tabs: CONTATOS_TABS },
  { key: "campanhas", test: (p) => ["/campaigns", "/contact-lists", "/campaigns-config", "/phrase-lists", "/flowbuilders", "/announcements"].some((r) => p.toLowerCase().startsWith(r)), tabs: CAMPANHAS_TABS },
  { key: "ia", test: (p) => ["/knowledge-base", "/ai-costs", "/prompts", "/pending-confirmations"].some((r) => p.startsWith(r)), tabs: IA_TABS },
  { key: "administracao", test: (p) => p.startsWith("/companies"), tabs: null },
  { key: "configuracoes", test: (p) => CONFIG_TABS.some((t) => p.startsWith(t.to)) || ["/sefaz-monitor", "/messages-api", "/allConnections"].some((r) => p.startsWith(r)), tabs: CONFIG_TABS },
];

export const getGroupForPath = (pathname) => GROUPS.find((g) => g.test(pathname)) || null;
